import { Entity } from '@shared/entities/entity';
import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('MachineAccounts')
export class MachineAccounts extends Entity {
  @JsonProperty('accountId', String)
  public accountId?: string = undefined;
  @JsonProperty('accountName', String)
  public accountName?: string = undefined;
}
